import { REVIEW_STATUS } from "v2/constants/extractionReview";
import type {
  ExtractionReview,
  ReviewCounts,
  ReviewField,
} from "v2/types/extractionReview.types";

// Single source of truth for progress counts, derived from field statuses. Used by the
// optimistic reducer (to rebuild review.counts) and per-section by the modal.
export const countReviewFields = (fields: ReviewField[]): ReviewCounts => ({
  conflicting: fields.filter((f) => f.status === REVIEW_STATUS.CONFLICT).length,
  review_remaining: fields.filter(
    (f) =>
      f.status === REVIEW_STATUS.PENDING || f.status === REVIEW_STATUS.CONFLICT
  ).length,
  confirmed: fields.filter((f) => f.status === REVIEW_STATUS.CONFIRMED).length,
  rejected: fields.filter((f) => f.status === REVIEW_STATUS.REJECTED).length,
  saved: fields.filter((f) => f.status === REVIEW_STATUS.SAVED).length,
  failed: fields.filter((f) => f.status === REVIEW_STATUS.FAILED).length,
});

export const hasUnsavedReview = (
  review: ExtractionReview | null | undefined
): boolean => {
  if (!review) return false;

  const { review_remaining: remaining, confirmed, failed } = review.counts;

  return remaining > 0 || confirmed > 0 || failed > 0;
};
